import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
  selectedFilters,
}) {
  const [serviceType, setServiceType] = useState("");
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("");
  const [nextServiceMonth, setNextServiceMonth] = useState("");
  const [nextServiceYear, setNextServiceYear] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState("");

  // Load already applied filters when modal opens
  useEffect(() => {
    if (show) {
      setServiceType(selectedFilters?.serviceType || "");
      setCompany(selectedFilters?.company || "");
      setStatus(selectedFilters?.status || "");
      setVehicleStatus(selectedFilters?.vehicleStatus || "");
      setNextServiceMonth(selectedFilters?.nextServiceMonth || "");
      setNextServiceYear(selectedFilters?.nextServiceYear || "");
    }
  }, [show, selectedFilters]);

  // Get unique service types from API data
  const serviceTypes = [
    ...new Set(apidata?.map((item) => item.serviceType).filter(Boolean)),
  ];

  // Get unique companies from:
  // vehicle -> id_type -> company
  const companies = [
    ...new Set(
      apidata?.map((item) => item.vehicle?.id_type?.company).filter(Boolean),
    ),
  ];

  // Get unique years from nextServiceDueDate
  const years = [
    ...new Set(
      apidata
        ?.map((item) => {
          if (!item.nextServiceDueDate) {
            return null;
          }

          return new Date(item.nextServiceDueDate).getFullYear();
        })
        .filter(Boolean),
    ),
  ].sort();

  const handleApply = () => {
    applyFilters({
      serviceType,
      company,
      status,
      vehicleStatus,
      nextServiceMonth,
      nextServiceYear,
    });

    onHide();
  };

  const handleRemove = () => {
    setServiceType("");
    setCompany("");
    setStatus("");
    setVehicleStatus("");
    setNextServiceMonth("");
    setNextServiceYear("");

    removeFilters();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Service Type */}
          <Form.Group className="mb-3">
            <Form.Label>Service Type</Form.Label>

            <Form.Select
              value={serviceType}
              onChange={(e) => setServiceType(e.target.value)}
            >
              <option value="">All Service Types</option>

              {serviceTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Vehicle Status */}
          <Form.Group className="mb-3">
            <Form.Label>Vehicle Status</Form.Label>

            <Form.Select
              value={vehicleStatus}
              onChange={(e) => setVehicleStatus(e.target.value)}
            >
              <option value="">All Vehicle Statuses</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Unassigned">Unassigned</option>
              <option value="Service_Center">Service Center</option>
            </Form.Select>
          </Form.Group>

          {/* Company */}
          <Form.Group className="mb-3">
            <Form.Label>Company</Form.Label>

            <Form.Select
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            >
              <option value="">All Companies</option>

              {companies.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Status */}
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>

            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All Statuses</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
            </Form.Select>
          </Form.Group>

          {/* Next Service Month */}
          <Form.Group className="mb-3">
            <Form.Label>Next Service Month</Form.Label>

            <Form.Select
              value={nextServiceMonth}
              onChange={(e) => setNextServiceMonth(e.target.value)}
            >
              <option value="">All Months</option>
              <option value="0">January</option>
              <option value="1">February</option>
              <option value="2">March</option>
              <option value="3">April</option>
              <option value="4">May</option>
              <option value="5">June</option>
              <option value="6">July</option>
              <option value="7">August</option>
              <option value="8">September</option>
              <option value="9">October</option>
              <option value="10">November</option>
              <option value="11">December</option>
            </Form.Select>
          </Form.Group>

          {/* Next Service Year */}
          <Form.Group className="mb-3">
            <Form.Label>Next Service Year</Form.Label>

            <Form.Select
              value={nextServiceYear}
              onChange={(e) => setNextServiceYear(e.target.value)}
            >
              <option value="">All Years</option>

              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemove}>
          Remove Filters
        </Button>

        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
